import Bank from './bank.interface'

export default interface User {
  instagram: Instagram[]
  youtube: Youtube[]
  twitter: Twitter[]
  auth0pic: string
  identities: Identity[]
  loginCount: number
  picture: string
  profileadditionalinfo: ProfileAdditionalInfo
  squidId: string
  providerAuthenticated: string
  name: string
  tiktok: TikTok[]
  statusProviders: StatusProviders
  banks: Bank[]
  profilewhitelabels: LandingPage[]
}

export interface ImpersonateInfo {
  impersonateAdmin?: boolean
  impersonateUser?: string
}

export class ProfileAdditionalInfo {
  profileId?: string
  auth0?: string
  email: string
  document: string
  name: string
  blog?: string
  birthday: string
  gender?: string
  phone?: string
  zipcode?: string
  address?: string
  addressNumber?: string
  complement?: string
  city?: string
  neighborhood?: string
  uf?: string
  country: string
  registeredFromSource?: any
  registeredFromCampaign?: any
  registeredFromMedium?: any
  createdAt?: string
  updatedAt?: string
  allowSMS?: number
  allowWhatsapp?: number
  allowSuggestionEmail?: number
  allowAffiliates?: number
  allowBrandLovers?: number
  allowSquidEngage?: number
  allowResearch?: number
  isPersonAccount?: number
  documentType: string
  hasSkip?: number
  language: string
  phoneValid?: number
  phoneValidCode?: any
  phoneValidCodeCreatedAt?: any
  race?: number
  recordEmployment?: string
  motherName?: string
  issuingCity?: string
  typeOfBusiness?: string
  registeredFromAdId?: any
  registeredFromContent?: any
  registeredFromAdName?: any
  portalRegistration?: number
  agent?: number
  showWarning?: number
  scenario?: string
  updateAddress?: number
  nationality: string
  lat: number | null
  lng: number | null
  squidId?: string
  socialName?: string

  constructor(profileAdditionalInfo: any = null) {
    this.profileId = profileAdditionalInfo?.profileId || ''
    this.auth0 = profileAdditionalInfo?.auth0 || ''
    this.email = profileAdditionalInfo?.email || ''
    this.document = profileAdditionalInfo?.document || ''
    this.name = profileAdditionalInfo?.name || ''
    this.blog = profileAdditionalInfo?.blog || ''
    this.birthday = profileAdditionalInfo?.birthday || ''
    this.gender = profileAdditionalInfo?.gender || ''
    this.phone = profileAdditionalInfo?.phone || ''
    this.zipcode = profileAdditionalInfo?.zipcode || ''
    this.address = profileAdditionalInfo?.address || ''
    this.addressNumber = profileAdditionalInfo?.addressNumber || ''
    this.complement = profileAdditionalInfo?.complement || ''
    this.city = profileAdditionalInfo?.city || ''
    this.neighborhood = profileAdditionalInfo?.neighborhood || ''
    this.uf = profileAdditionalInfo?.uf || ''
    this.country = profileAdditionalInfo?.country || ''
    this.registeredFromSource = profileAdditionalInfo?.registeredFromSource || ''
    this.registeredFromCampaign = profileAdditionalInfo?.registeredFromCampaign || ''
    this.registeredFromMedium = profileAdditionalInfo?.registeredFromMedium || ''
    this.createdAt = profileAdditionalInfo?.createdAt || ''
    this.updatedAt = profileAdditionalInfo?.updatedAt || ''
    this.allowSMS = profileAdditionalInfo?.allowSMS || 0
    this.allowWhatsapp = profileAdditionalInfo?.allowWhatsapp || 0
    this.allowSuggestionEmail = profileAdditionalInfo?.allowSuggestionEmail || 0
    this.allowAffiliates = profileAdditionalInfo?.allowAffiliates || 0
    this.allowBrandLovers = profileAdditionalInfo?.allowBrandLovers || 0
    this.allowResearch = profileAdditionalInfo?.allowResearch || 0
    this.allowSquidEngage = profileAdditionalInfo?.allowSquidEngage || 0
    this.isPersonAccount = profileAdditionalInfo?.isPersonAccount || 1
    this.documentType = profileAdditionalInfo?.documentType || ''
    this.hasSkip = profileAdditionalInfo?.hasSkip || 0
    this.language = profileAdditionalInfo?.language || 'en'
    this.phoneValid = profileAdditionalInfo?.phoneValid || 0
    this.phoneValidCode = profileAdditionalInfo?.phoneValidCode || ''
    this.phoneValidCodeCreatedAt = profileAdditionalInfo?.phoneValidCodeCreatedAt || ''
    this.race = profileAdditionalInfo?.race || ''
    this.recordEmployment = profileAdditionalInfo?.recordEmployment || ''
    this.motherName = profileAdditionalInfo?.motherName || ''
    this.issuingCity = profileAdditionalInfo?.issuingCity || ''
    this.typeOfBusiness = profileAdditionalInfo?.typeOfBusiness || ''
    this.registeredFromAdId = profileAdditionalInfo?.registeredFromAdId || ''
    this.registeredFromContent = profileAdditionalInfo?.registeredFromContent || ''
    this.registeredFromAdName = profileAdditionalInfo?.registeredFromAdName || ''
    this.portalRegistration = profileAdditionalInfo?.portalRegistration || ''
    this.agent = profileAdditionalInfo?.agent || ''
    this.showWarning = profileAdditionalInfo?.showWarning || ''
    this.scenario = profileAdditionalInfo?.scenario || ''
    this.updateAddress = profileAdditionalInfo?.updateAddress || ''
    this.nationality = profileAdditionalInfo?.nationality || ''
    this.lat = profileAdditionalInfo?.lat || null
    this.lng = profileAdditionalInfo?.lng || null
    this.socialName = profileAdditionalInfo?.socialName || ''
  }

  toValidation? = (fields: Array<string> = []) => {
    const response: any = {}
    for (const f in this) {
      if ((fields?.length && fields?.includes(f)) || !fields?.length) {
        response[f] = !!this[f]
      }
    }
    return response
  }

  toUpdateDakenPayload? = () => {
    let document = ''
    if (this.document) {
      if (this.documentType === 'CPF') {
        document = this.document.replace(/[^0-9]/gi, '')
      }
      if (this.documentType === 'RUT') {
        document = this.document.replace(/[^0-9k]/gi, '')
      }
      if (this.documentType === 'International') {
        document = this.document.replace(/[^0-9A-Z]/gi, '')
      }
    }
    return {
      name: this.name,
      blog: this.blog || '',
      gender: this.gender,
      birthday: this.birthday,
      email: this.email,
      phone: this.phone,
      phoneValid: this.phoneValid,
      zipcode: this.zipcode,
      address: this.address,
      addressNumber: this.addressNumber,
      complement: this.complement || '',
      city: this.city,
      uf: this.uf,
      country: this.country,
      document: document || '',
      documentType: this.documentType || '',
      neighborhood: this.neighborhood || '',
      nationality: this.nationality,
      race: this.race || null,
      language: this.language || 'en',
      lng: this.lng || null,
      lat: this.lat || null,
      socialName: this.socialName || '',
    }
  }
}

export interface Instagram {
  id: string
  user_id?: string
  username: string
  exists: boolean
  searchable: number
  macro: number
  notSearchReason: string
  brandUser: number
  picture: string
  fullName: string
  email: string
  bio?: string
  website?: string
  language?: string
  isBusiness: number
  hasSkip?: number
  facebookUserId: string
  facebookPageId: string
  instagramBusinessId: string
  scrapperEngagementRate: number
  engagementRate?: number
  totalMedias: number
  medias: number
  followers: number
  follows: number
  likes: number
  comments: number
  tier: string
  createdAt: string
  updatedAt: string
  logstashProcessedAt: any
  score?: number
  score1?: number
  score2?: number
  score3?: number
  score4?: number
  score5?: number
  storiesEngagementRate?: number
  postEffectiveReach?: number
  storiesEffectiveReach?: number
  profileViews: number
  hasMediaKit: number
  categorizedAt?: string
  averageComments: number
  averageCommentsImage: number
  averageCommentsVideo: number
  averageCommentsCarousel: number
  averageLikes: number
  averageLikesImage: number
  averageLikesVideo: number
  averageLikesCarousel: number
  commentLikesRate: number
  commentsRate: number
  totalStoriesImpressions?: number
  totalStoriesReach?: number
  totalStoriesReplies?: number
  totalStoriesTapBacks?: number
  totalStoriesTapFowardExits: number
  totalPostsReach?: number
  totalPostsSaves?: number
  totalPostsImpressions?: number
  averageSaved: number
  averageSavedImage: number
  averageSavedVideo: number
  averageSavedCarousel: number
  averageTapBacks: number
  averageTapBacksImage: number
  averageTapBacksVideo: number
  averageReplies: number
  averageRepliesImage: number
  averageRepliesVideo: number
  averageTapFowardExits: number
  averageTapFowardExitsImage: number
  averageTapFowardExitsVideo: number
  completeVideoStoriesRate: number
  numberPostsActivityScore?: number
  numberStoriesScore?: number
  daysPostsScore?: number
  daysStoriesScore?: number
  advertisingPostsEngagementRate?: number
  noAdvertisingPostsEngagementRate?: number
  advertisingStoriesEngagementRate?: number
  noAdvertisingStoriesEngagementRate?: number
  advertisingContentPercentage?: number
  advertisingPostsPercentage?: number
  advertisingStoriesPercentage?: number
  postImageEngagementRate?: number
  postCarouselEngagementRate?: number
  postVideoEngagementRate?: number
  storiesVideoEngagementRate?: number
  storiesImageEngagementRate?: number
  storiesCompleteEngagementRate?: number
  averagePostsReach: number
  averagePostsImpressions: number
  averagePostsFrequency: number
  averageStoriesReach: number
  averageStoriesImpressions: number
  averageStoriesFrequency: number
  adPostPermanceEngagementRate?: number
  adStoriesPermanceEngagementRate?: number
  identifyAt?: string
  socialNetworkProfilesCache?: Cache[]
}

export interface Cache {
  contentType: string
  contentValue: number
  profileId: string
  createdAt: string
  updatedAt: string
}

export interface Youtube {
  id: string
  googleId: string
  exists: boolean
  searchable: number
  notSearchReason: string
  email: string
  channelTitle: string
  username: string
  picture: string
  fullName: string
  description: any
  bio?: string
  customUrl: string
  country: string
  since: string
  followers: number
  subscribers: number
  engagementRate?: number
  engagementRatePositive: number
  engagementRateNegative: number
  viewsRate: number
  viewsMedian: number
  comments: number
  identificationComments: number
  identificationLikes: number
  identificationDislikes: number
  averageComments: number
  averageLikes: number
  averageDislikes: number
  shares: number
  averageShares: number
  commentLikesRate: number
  commentViewsRate: number
  averageViewsDuration: number
  averageViewPercentage: number
  averageVideoDuration: number
  videoEffectiveReach: number
  videos: number
  identificationVideos: number
  views: number
  identificationViews: number
  privacyStatus: string
  language?: string
  createdAt: string
  updatedAt: string
  logstashProcessedAt: any
  macro: number
  brandUser: number
}

export interface Twitter {
  id: string
  username: string
  picture: string
  followers: number
  createdAt: string
  updatedAt: string
  brandUser: number
  exists: boolean
  macro: number
  engagementRate?: number
  totalRetweets: number
  totalLikes: number
  totalRetweetsReceived: number
  averageLikes: number
  averageRetweets: number
  totalTweets: number
  averageRepliesByLikes: number
  averageRepliesByTweet: number
  repliesRate: number
  effectiveImpressionReach: number
  averageImpressions: number
  countReplies: number
  adTweetsCount: number
  engagementRateAd: number
  tweetPostAdPerformance: number
}

export interface TikTok {
  id: string
  openId: string
  unionId: string
  exists: boolean
  verified: boolean
  username: string
  nickname: string
  macro: number
  brandUser: number
  picture: string
  bio?: string
  engagementRate?: number
  followers: number
  following: number
  likes: number
  averageLikes: number
  comments: number
  averageComments: number
  shares: number
  averageShares: number
  views: number
  averageViews: number
  createdAt: string
  updatedAt: string
  isValid: boolean
  status: any
}
export interface Identity {
  user_id: string
  id: string
  name: string
  username: string
  picture: string
  connection: string
  google_id?: string
  email?: string
}

export interface StatusProviders {
  instagram: StatusProvider[]
  'google-oauth2': StatusProvider[]
  twitter: StatusProvider[]
  tiktok: StatusProvider[]
  banks: Bank[]
  profilewhitelabels: Profilewhitelabel[]
}

export interface StatusProvider {
  ok: boolean
  id: string
  tokenExpired: boolean
  businessIsValid?: boolean
  isBusiness?: boolean
  statusToken?: string
}

export interface Profilewhitelabel {
  tokenExpired: boolean
}

export interface LandingPagesInfos {
  profileId: string
  landingPagesInfos: Array<LandingPage>
}

export interface LandingPage {
  _id: string
  domains?: Array<string>
  name: string
  images?: {
    favicon?: { url: string }
    logo?: { url: string }
    negativeLogo?: { url: string }
    backgroundDesktop?: { url: string }
    backgroundMobile?: { url: string }
  }
  blockingInformation?: { isBlocked: boolean }
}

export interface Page {
  id?: string
  user_id?: string
  idToken: string
  expiresIn: number
  squidId: string
  idTokenPayload: User
  statusProviders: StatusProviders
  bindedProfileInfo: Identity
  instagram?: Instagram
}

export interface UserAuth {
  idToken: string
  expiresIn: number
  squidId: string
}

export interface VerifyEmailResponse {
  status: boolean
  message: string
  token: string
  email: string
}

export interface FacebookDiscoveryUser {
  id: string
  ig_id?: string
  username: string
  profile_picture_url: string
  followers_count?: number
  name?: string
  briography?: string
}
